import { ProductListTextHeaderModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import { Typography } from 'components/generic/typography';
import React from 'react';

export default function TextHeader({ model: { name, description } }: { model: ProductListTextHeaderModel }) {
    return (
        <Layout.Section>
            <div>
                <Typography.Headline as="h1" size="L">
                    {name}
                </Typography.Headline>
                {description && <Typography.Body as="span">{description}</Typography.Body>}
            </div>
        </Layout.Section>
    );
}
